'use strict';

var novicell = novicell || {};

novicell.search = novicell.search || new function () {

    var body = document.querySelector('#site');
    var searchInput = document.querySelector('.search-overlay-input-container__input');
    var searchOverlay = document.querySelector('#js-search-overlay');
    var searchButtons = document.querySelectorAll('#js-search-overlay-trigger');
    var isOpen = false;

    this.init = function () {

        if (!searchButtons) {
            return;
        }

        for (let i = 0; i < searchButtons.length; i++) {
            var searchButton = searchButtons[i];

            searchButton.addEventListener('click', clickSearchButton);
        }

        // Open search overlay
    };

    function clickSearchButton(e) {
        e.preventDefault();
        if (!isOpen) {
            openSearchOverlay();
        } else {
            closeSearchOverlay();
        }
    }

    function openSearchOverlay() {
        document.addEventListener('keydown', handleEsc, true);
        document.addEventListener('click', handleClick, true);
        body.classList.add('search-overlay-open');
        searchInput.focus();

        isOpen = true;
    }

    function closeSearchOverlay() {
        body.classList.remove('search-overlay-open');
        searchInput.blur();
        searchInput.value = '';
        document.removeEventListener('keydown', handleEsc, true);
        document.removeEventListener('click', handleClick, true);

        isOpen = false;
    }

    function handleEsc(e) {
        if (e.keyCode === 27) {
            closeSearchOverlay();
        }
    }

    function handleClick(e) {
        var targetElement = e.target;

        if (targetElement.closest('#js-search-overlay') || targetElement.closest('#js-search-overlay-trigger')) {
            return;
        }

        // This is a click outside.
        closeSearchOverlay();
    }
}();
